import { useBranding } from "@needl-ai/common/branding";

import ICRAResearchAssistDisclaimer from "./ICRAResearchAssistDisclaimer";
import PwCDisclaimer from "./PwCDisclaimer";

const DisclaimerModal = () => {
  const { activeBranding } = useBranding();

  switch (activeBranding) {
    case "pwc":
      return <PwCDisclaimer />;
    case "icra-researchassist":
      return <ICRAResearchAssistDisclaimer />;
    default:
      return null;
  }
};

export default DisclaimerModal;
